const GOOGLE_API = {
	timezone: "https://maps.googleapis.com/maps/api/timezone",
	place: "https://places.googleapis.com/v1/places",
	validateAddress: "https://addressvalidation.googleapis.com/v1:validateAddress",
};

export { GOOGLE_API };
